// src/firebase/booking-api.js
import { db } from "./config";
import {
  collection,
  doc,
  addDoc,
  setDoc,
  getDoc,
  serverTimestamp,
} from "firebase/firestore";

export async function createAppointment(clientId, data) {
  if (!clientId) throw new Error("Missing clientId");

  // וודא שדוקומנט הלקוח קיים - אם לא, צור אותו
  const clientRef = doc(db, "clients", clientId);
  const clientDoc = await getDoc(clientRef);
  
  if (!clientDoc.exists()) {
    // צור דוקומנט לקוח חדש עם נתונים בסיסיים
    await setDoc(clientRef, {
      active: true,
      name: clientId,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
  }

  // צור את התור ב-subcollection
  const colRef = collection(db, "clients", clientId, "appointments");

  await addDoc(colRef, {
    clientId,
    ...data,
    createdAt: serverTimestamp(),
  });
}
